import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AppProvider, useApp } from "./context/AppContext";
import { Sidebar } from "./components/Sidebar";
import { Topbar } from "./components/Topbar";
import Dashboard from "./pages/Dashboard";
import SchedulePage from "./pages/SchedulePage";
import CoveragePage from "./pages/CoveragePage";
import AgentsPage from "./pages/AgentsPage";
import ProfessionsPage from "./pages/ProfessionsPage";
import WorkstationsPage from "./pages/WorkstationsPage";
import MasterWeekBuilder from "./pages/MasterWeekBuilder";
import TermPlanner from "./pages/TermPlanner";
import AbsencesPage from "./pages/AbsencesPage";
import LoginPage from "./pages/LoginPage";

function BootScreen({ label }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg text-muted gap-3">
      <Loader2 className="w-5 h-5 animate-spin text-primary" />
      <span className="mono text-sm">{label}</span>
    </div>
  );
}

function Shell() {
  const { loading } = useApp();
  if (loading) return <BootScreen label="Booting CP-SAT engine…" />;
  return (
    <div className="flex min-h-screen bg-bg">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar />
        <main className="flex-1 p-6">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/coverage" element={<CoveragePage />} />
            <Route path="/professions" element={<ProfessionsPage />} />
            <Route path="/agents" element={<AgentsPage />} />
            <Route path="/workstations" element={<WorkstationsPage />} />
            <Route path="/builder" element={<MasterWeekBuilder />} />
            <Route path="/term" element={<TermPlanner />} />
            <Route path="/absences" element={<AbsencesPage />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

function Root() {
  const { user, checking } = useAuth();
  if (checking) return <BootScreen label="Authenticating…" />;
  if (!user) return <LoginPage />;
  return (
    <AppProvider>
      <Shell />
    </AppProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#161618",
              border: "1px solid #242426",
              color: "#F5F5F7",
              borderRadius: "3px",
              fontFamily: "Inter, sans-serif",
            },
          }}
        />
        <Root />
      </BrowserRouter>
    </AuthProvider>
  );
}
